export default `#define q(p) length(vec2(mod(p.x,.4)-.2,p.y+sin(t)))
#define R(x) vec2(.3,0.0)*_((p.z+t)*9.+x)
float de(vec3 p){
  float t=time;
  return min(q((p.xy+R(0.))),q((p.xy+R(3.14))))*.2;
}`